import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
    width: '100%',
  },
  subTitle: {
    color: theme.palette.labraText.primary,
    fontWeight: 500,
    fontSize: '16px',
    marginBottom: theme.spacing(3),
  },
}))
